/**
 * Configuration for the used API endpoint
 */
import axios from "axios";

/**
 * Returns the base URL of the API endpoint.
 * Production builds (served behind nginx) use the relative /api/ path.
 * Local npm start talks to the server on port 3030 directly.
 * @returns The base URL of the API endpoint
 */
const getBaseUrl = () => {
  if (process.env.NODE_ENV === "production") {
    return "/api/";
  }
  return "http://localhost:3030/api/";
};

export default axios.create({
  baseURL: getBaseUrl(),
  responseType: "json",
  withCredentials: true,
});
